import React from 'react';
import styles from './HomeSecondSection.module.css';

export function CTAButton() {
  const openInstagramReels = () => {
    window.open("https://www.instagram.com/maa_mangala_studio/reels/", "_blank"); // Opens MaaMangala Studio's Reels in a new tab
  };

  return (
    <button className={styles.ctaButton} onClick={openInstagramReels}>
      <span className={styles.ctaText}>Explore the Experience</span>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/ce40d236558048348d774cfe0f3039b9/5a4342b708d25494a820fd261b375e1b8365cb18031c0513efae019c7e284301?apiKey=ce40d236558048348d774cfe0f3039b9&"
        className={styles.ctaIcon}
        alt="Capture"
      />
    </button>
  );
}
